"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppVersion = exports.getAppName = void 0;
var getAppName = function (stack) {
    // ex. https://450.mit.webplatform-hybridapps-staging-01.topdanmark.cloud/hybridapps/c9-stakeholderview-selector/latest/static/js/index.js
    if (!stack)
        return 'undefined';
    if (!stack[0])
        return 'undefined';
    if (!stack[0].fileName)
        return 'undefined';
    var parts = stack[0].fileName.split('/');
    var index = parts.findIndex(function (item) { return item === 'hybridapps'; });
    if (index === -1)
        return 'undefined';
    var appName = parts[index + 1];
    return appName;
};
exports.getAppName = getAppName;
var getAppVersion = function (stack) {
    // ex. https://450.mit.webplatform-hybridapps-staging-01.topdanmark.cloud/hybridapps/c9-stakeholderview-selector/latest/static/js/index.js
    if (!stack)
        return 'undefined';
    if (!stack[0])
        return 'undefined';
    if (!stack[0].fileName)
        return 'undefined';
    var parts = stack[0].fileName.split('/');
    var index = parts.findIndex(function (item) { return item === 'hybridapps'; });
    if (index === -1)
        return 'undefined';
    var appVersion = parts[index + 2];
    return appVersion;
};
exports.getAppVersion = getAppVersion;
